export default {"src":"/_next/static/media/timerDark.97920c50.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};